const REFUND_STATUS = {
	NONE: 0,
	PENDING: 1,
	CONFIRMED: 2,
	REFUNDED: 10,
	CANCELED: -100,
}

export { REFUND_STATUS }
export default REFUND_STATUS



// WEBPACK FOOTER //
// ./src/enums/refundStatus.js